/*Core values */
window.addEventListener('DOMContentLoaded', () => {

  if ($('.core-values-slider').length) {
    var buttonCoreValuesPrev = document.getElementsByClassName('core-values-slider__arrow-prev')[0];
    var buttonCoreValuesNext = document.getElementsByClassName('core-values-slider__arrow-next')[0];

    $(".core-values-slider").slick({
      prevArrow: buttonCoreValuesPrev,
      nextArrow: buttonCoreValuesNext,
      speed: 700,
      slidesToShow: 1,
      swipeToSlide: false,
      infinite: false,
      dots: true,
      arrows: true,
      centerMode: true,
      centerPadding: "20%",
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            centerPadding: "3%",
          },
        },
      ],
    });
  }

  $(".core-value-showtext").on('click', function(e) {
      e.preventDefault();         
      var target = $(this).parent().find('div.mobile-only');
      
      if ( target.hasClass('active') ) {
        target.text(target.attr('data-shorttext'));
        console.log("Active");
      } else {
        target.text(target.attr('data-text'));
        console.log("Non active");
      }
      target.toggleClass('active');
  });
    
});